import React from 'react';
import { Link } from 'react-router-dom';
import { FaComments, FaLanguage, FaTachometerAlt } from 'react-icons/fa';
import { SiGooglebigquery } from "react-icons/si";

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-pl_bg_light_5 to-pl_bg_light_3 flex items-center justify-center">
      <div className="text-center max-w-3xl mx-auto px-4">
        {/* Header */}
        <div className="mb-16">
          <h1 className="text-4xl md:text-6xl font-bold text-pl_txt_light_1 mb-4">
            Log Viewer
          </h1>
          <p className="text-xl text-pl_txt_light_3">
            Choose your log type to get started
          </p>
        </div>

        {/* Buttons */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-7xl mx-auto mb-16">
          {/* Chat Logs Button */}
          <Link
            to="/chatlogs"
            aria-label="Chat Logs"
            className="group bg-pl_bg_light_3 p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 border border-pl_border_light_1 hover:border-pl_prim_color_1"
          >
            <div className="flex flex-col items-center space-y-4">
              <div className="w-16 h-16 bg-gradient-to-br from-pl_prim_color_1 to-pl_prim_color_2 rounded-full flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                <FaComments className="text-2xl text-pl_bg_light_3" />
              </div>
              <div>
                <h2 className="text-2xl font-bold text-pl_txt_light_1 mb-2">Chat</h2>
                <p className="text-pl_txt_light_3 text-sm">
                  View and manage chat conversation logs
                </p>
              </div>
            </div>
          </Link>

          {/* Translation Logs Button */}
          <Link
            to="/translatelogs"
            aria-label="Translation Logs"
            className="group bg-pl_bg_light_3 p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 border border-pl_border_light_1 hover:border-pl_prim_color_2"
          >
            <div className="flex flex-col items-center space-y-4">
              <div className="w-16 h-16 bg-gradient-to-br from-pl_prim_color_2 to-pl_prim_color_3 rounded-full flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                <FaLanguage className="text-2xl text-pl_bg_light_3" />
              </div>
              <div>
                <h2 className="text-2xl font-bold text-pl_txt_light_1 mb-2">Translate</h2>
                <p className="text-pl_txt_light_3 text-sm">
                  View and manage translation logs
                </p>
              </div>
            </div>
          </Link>

          {/* Query Classification Logs Button */}
          <Link
            to="/queryclassificationlogs"
            aria-label="Query Classification Logs"
            className="group bg-pl_bg_light_3 p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 border border-pl_border_light_1 hover:border-pl_prim_color_3"
          >
            <div className="flex flex-col items-center space-y-4">
              <div className="w-16 h-16 bg-gradient-to-br from-pl_prim_color_3 to-pl_prim_color_2 rounded-full flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                <SiGooglebigquery className="text-2xl text-pl_bg_light_3" />
              </div>
              <div>
                <h2 className="text-2xl font-bold text-pl_txt_light_1 mb-2">Query Classification</h2>
                <p className="text-pl_txt_light_3 text-sm">
                  View and manage query classification logs
                </p>
              </div>
            </div>
          </Link>

          {/* Master Dashboard Button */}
          <Link
            to="/master-dashboard"
            aria-label="Master Dashboard"
            className="group bg-pl_bg_light_3 p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 border border-pl_border_light_1 hover:border-purple-500"
          >
            <div className="flex flex-col items-center space-y-4">
              <div className="w-16 h-16 bg-gradient-to-br from-purple-500 to-purple-600 rounded-full flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                <FaTachometerAlt className="text-2xl text-pl_bg_light_3" />
              </div>
              <div>
                <h2 className="text-2xl font-bold text-pl_txt_light_1 mb-2">Master Dashboard</h2>
                <p className="text-pl_txt_light_3 text-sm">
                  Comprehensive overview of all system logs
                </p>
              </div>
            </div>
          </Link>
        </div>

        {/* Footer */}
        <div className="mt-8 text-sm text-pl_txt_light_3">
          <p>Select an option above to access your logs</p>
        </div>
      </div>
    </div>
  );
};

export default LandingPage;